import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=4720c6b7&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720c6b7",
  null
  
)

component.options.__file = "src/demo/pages/mall/orderPay.vue"
export default component.exports